import { Lender, LoanTerm } from 'enums/ApplicationsVariables';

export const LENDERS_ONLY_ALLOWED_TO_VIEW_OFFER: Lender[] = [Lender.Bhg, Lender.Prosper, Lender.Quilo];

export const POS_TERMS_BY_LENDER: Partial<Record<Lender, LoanTerm[]>> = {
  [Lender.USAlliance]: [
    LoanTerm.ThreeYears,
    LoanTerm.FourYears,
    LoanTerm.FiveYears,
    LoanTerm.SixYears,
    LoanTerm.SevenYears,
  ],
  [Lender.Mit]: [LoanTerm.ThreeYears, LoanTerm.FiveYears, LoanTerm.SevenYears, LoanTerm.TenYears],
  [Lender.InFirstFcu]: [LoanTerm.ThreeYears, LoanTerm.FiveYears, LoanTerm.SevenPointFiveYears, LoanTerm.TenYears],
  [Lender.MsdFcu]: [LoanTerm.ThreeYears, LoanTerm.FiveYears, LoanTerm.SevenYears],
  [Lender.CopperStateCu]: [LoanTerm.ThreeYears, LoanTerm.FiveYears, LoanTerm.SevenPointFiveYears, LoanTerm.TenYears],
};

export const THIRTY_YEARS_TERM_MIN_VANTAGE_SCORE = 740;
